import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { throwError as observableThrowError, Observable, of } from "rxjs";
import { LoyaltyCardTypeModel } from "../../models/entity/loyalty/loyalty-card-type.model";
import { BaseRestService } from "../base-rest.service";
import { SessionStorageService } from "../session-storage.service";

@Injectable({
  providedIn: "root"
})
export class LoyaltyCardTypeService extends BaseRestService {
  constructor(protected httpClient: HttpClient, protected sessionStorageService: SessionStorageService) {
    super(httpClient, sessionStorageService);
  }


  // Müşteri tipleri
  getLoyaltyCardTypes(): Observable<LoyaltyCardTypeModel[]> {
    const url = `/loyalty-card-types`;
    return this.httpGet<LoyaltyCardTypeModel[]>(url)
      .pipe(catchError(this.errorHandler));
  }

  //Müşteri tipi ekle
  addLoyaltyCardType(data) {
    const url = `/loyalty-card-types`;
    return this.httpPost<LoyaltyCardTypeModel>(url, data)
      .pipe(catchError(this.errorHandler));
  }

  //Müşteri tipi güncelle
  updateLoyaltyCardType(id, data): Observable<LoyaltyCardTypeModel> {
    const url = `/loyalty-card-types/${id}`;
    return this.httpPut<LoyaltyCardTypeModel>(url, data)
      .pipe(catchError(this.errorHandler));
  }

  //Müşteri tipi sil
  deleteLoyaltyCardType(id) {
    const url = `/loyalty-card-types/${id}`;
    return this.httpDelete(url).pipe(catchError(this.errorHandler));
  }
  errorHandler(error: HttpErrorResponse) {
    // console.log("service:"+error);
    return observableThrowError(error);
  }
}
